import React from 'react';
import './footer.css';
const env = require("../../config.js").default;
class Footer extends React.Component {

  renderFooter(){
    try{
      return(
        <p>{window.cc.companyInfo.name} - {window.cc.companyInfo.address}, {window.cc.companyInfo.zip}, {window.cc.companyInfo.city} ({window.cc.companyInfo.province}) - {window.cc.companyInfo.country}<br />
          <i className="fas fa-globe"></i>: <a target="_blank" rel="noopener noreferrer" href={window.cc.companyInfo.site}>{window.cc.companyInfo.site.replace("http://", "").replace("https://", "")}</a>&nbsp;|<wbr/>&nbsp;
          {window.cc.companyInfo.phone ? <><i className="fas fa-phone"></i>: <a href={"tel:" + window.cc.companyInfo.phone}>{window.cc.companyInfo.phone}</a>&nbsp;|<wbr />&nbsp;</> : ""}
          {window.cc.companyInfo.email ? <><i className="fas fa-at"></i>: <a href={"mailto:" + window.cc.companyInfo.email}>{window.cc.companyInfo.email}</a></> : ""}
          <br/>
          P.Iva: {window.cc.companyInfo.piva}
        </p>
      )
    }catch(e){return(<></>)}
  }

  render(){
    var d = new Date();
    return(
      <div id="footer" className="footer_home">
				<div id="copyright" className="container-fluid">
					<div className="row">
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12" id="portal-footer">
              {this.renderFooter()}
						</div>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 content_logo_footer">
              <a className="copyLogo row" href="https://www.softway.it/" target="_blank" rel="noopener noreferrer" title="SOFTWAY">
                <div className='col-12 text-right p-0'>
                  <img className="swanLogo poweredby" src={env.STATIC + "images/logo-swan.svg"} alt="Swan" title="Swan" />
								  <img className="poweredby" src={env.STATIC + "images/powered.png"} alt={process.env.REACT_APP_VERSION + " SOFTWAY powered "} title={process.env.REACT_APP_VERSION + " SOFTWAY powered "} />
                </div>
                <div id="softwayLogo" className='col-12 text-left p-0'>
                  <small className="text-right">© 1993-{d.getFullYear()} </small>
                </div>
							</a>
						</div>
					</div>
				</div>
			</div>
    )
  }
}

export default Footer;
